import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/user.svg'


const _hoisted_1 = { class: "form-group flex m-2 justify-center" }
const _hoisted_2 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaskInput = _resolveComponent("MaskInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: _imports_0,
      class: "w-6 mr-4"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MaskInput, {
        class: "pl-10 p-2 bg-inherit border-2 border-blue-100 text-blue-500 focus-visible:border-blue-300 rounded-xl w-full",
        "v-model": _ctx.phone,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPhone($event.target.value))),
        mask: "(##) #####-####",
        placeholder: "(99) 99999-9999",
        inputmode: "numeric"
      }, null, 8, ["v-model"]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "absolute left-2 top-1/2 transform -translate-y-1/2 text-blue-500" }, " +55 ", -1))
    ])
  ]))
}